<div class="list-block">
    <div class="container icon-container" [ngClass]="classes">
        <finder-component-header
            [data]="data.sections"
        ></finder-component-header>
        <ul class="list-elements">
            <li *ngFor="let paragraph of data.descriptions">
                <div class="list-element-title">
                    <finder-font-icon
                        size="m"
                        [ngStyle]="iconStyles"
                        *ngIf="paragraph.webfont"
                        [htmlEntity]="paragraph.webfont.htmlCharacter">
                    </finder-font-icon>
                    <span *ngIf="paragraph.sections.title"
                        class="list-element-subtitle"
                        [innerHTML]="paragraph.sections.title | safeHtml"></span>
                </div>
                <div *ngIf="paragraph.sections.body"
                    class="list-element-text dynamic-html"
                    [innerHTML]="paragraph.sections.body | safeHtml"></div>
            </li>
        </ul>
    </div>
</div>
